import { defineMobileFormWindow } from "@app/overlay";
import {
    StockFinishedGoodsShipmentContentForm,
    type StockFinishedGoodsShipmentContentFormProps,
} from "./components/StockFinishedGoodsShipmentContentForm/StockFinishedGoodsShipmentContentForm";

/** Окна карточки отгрузки СГП по НС. */
export const stockFinishedGoodsShipmentCardWindows = {
    content: defineMobileFormWindow<StockFinishedGoodsShipmentContentFormProps>({
        key: "stock.finishedGoodsShipment.content",
        title: "Отгрузка продукции",
        component: StockFinishedGoodsShipmentContentForm,
    }),
} as const;
